export const DEVICE_WIDTH = 208;

export const SPACE_BETWEEN_IMAGES = 8;

export const AMOUNT_IMAGES = 2;

export const MAX_RATIO = 1.5;
